import { render, staticRenderFns } from "./StockSlipTransfer.vue?vue&type=template&id=d2dd308c&scoped=true"
import script from "./StockSlipTransfer.vue?vue&type=script&lang=js"
export * from "./StockSlipTransfer.vue?vue&type=script&lang=js"
import style1 from "./StockSlipTransfer.vue?vue&type=style&index=1&id=d2dd308c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dd308c",
  null
  
)

export default component.exports